import { createIndicator } from '~/modules/SDK/indicator/createIndicator';
export const freeman_ma = createIndicator({
    displayName: '均線',
    id: 'freeman-ma',
    constructorScope: {
        init(context, inputCallback) {
            return;
        },
        main(context, inputCallback) {
            const closeArray = this.ohlc.closeArray;
            const ma = this.PineJS.Std.sma(closeArray, 20, this._context);
            return [ma];
        },
    },
    metainfo: {
        plots: [
            {
                id: 'plot_0',
                type: 'line',
            },
        ],
        palettes: {
            palette_0: {
                colors: {
                    0: {
                        name: 'Color 0',
                    },
                    1: {
                        name: 'Color 1',
                    },
                },
            },
        },
        defaults: {
            styles: {
                plot_0: {
                    linestyle: 0,
                    linewidth: 1,
                    plottype: 0,
                    trackPrice: !1,
                    transparency: 0,
                    visible: !0,
                    color: '#00ffff',
                },
            },
        },
        styles: {
            plot_0: {
                title: '均線',
                histogramBase: 0,
            },
        },
        is_price_study: !0,
        inputs: [],
        scriptIdPart: '',
    },
});
